(function () {
    'use strict';

    function excludeSelectedResourcePartners() {
        return function (items, resourcePartnerConnections) {
            var allResourcePartnerIds = _.map(resourcePartnerConnections, (function (resourcePartnerConnection) {
                return resourcePartnerConnection.ResourcePartnerId;
            }));

            var filteredData = [];
            angular.forEach(items, function (item) {
                if (!(_.include(allResourcePartnerIds, item.Id))) {
                    filteredData.push(item);
                }
            });
            return filteredData;
        };
    }

    angular.module('ecap.workflow').filter('excludeSelectedResourcePartners', excludeSelectedResourcePartners);
})();
